export default __webpack_public_path__ + "static/carousel-3-db50e653d2fa1a356a8a787657ce7093.png";